import { EAEAEA_PIXEL } from "@faire/deprecated-retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { optimizeImageUrlFillRectangle } from "@faire/web/common/images/optimizeImages";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { optimizeProductImageUrl } from "@faire/web/common/transform-images";
import React from "react";
import styled from "styled-components";

interface InsightCardProductImageProps {
  image: IImage | undefined;
  asCarouselTile: boolean;
  shouldShowVerticalImagery: boolean;
  isCompact: boolean;
}

export const InsightCardProductImage: React.FC<
  InsightCardProductImageProps
> = ({ image, asCarouselTile, shouldShowVerticalImagery, isCompact }) => {
  const isSSR = useIsSSR();

  return (
    <Image
      src={
        image
          ? getImageUrl(image, isSSR, !!shouldShowVerticalImagery, isCompact)
          : EAEAEA_PIXEL
      }
      alt={image?.alt_text}
      $squared={asCarouselTile && !shouldShowVerticalImagery}
      loading={undefined}
      style={{ width: "100%", height: "100%" }}
      width="100%"
      height="100%"
    />
  );
};

const Image = styled.img<{ $squared?: boolean }>`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  ${(props) => (props.$squared ? "aspect-ratio: 1;" : "")}
`;

const getImageUrl = (
  image: IImage,
  isSSR: boolean,
  shouldShowVerticalImagery: boolean,
  compact: boolean
) => {
  const imageWidth = compact
    ? PRODUCT_COMPACT_IMAGE_WIDTH
    : PRODUCT_IMAGE_WIDTH;
  const imageHeight = compact
    ? PRODUCT_COMPACT_IMAGE_HEIGHT
    : PRODUCT_IMAGE_HEIGHT;
  if (shouldShowVerticalImagery) {
    return optimizeImageUrlFillRectangle(
      image,
      isSSR,
      imageWidth,
      imageHeight,
      { ignoreResizeTag: true }
    );
  }
  return optimizeProductImageUrl(image, isSSR, imageWidth);
};

const PRODUCT_IMAGE_WIDTH = 200;
const PRODUCT_IMAGE_HEIGHT = 266;
const PRODUCT_COMPACT_IMAGE_WIDTH = 120;
const PRODUCT_COMPACT_IMAGE_HEIGHT = 160;
